import { useQuery } from '@tanstack/react-query';

import * as ApiOrder from '@Api/Order';
import useNavigation from '@Navigation/useNavigation';
import { useRequest } from '@Contexts/Request';
import * as Cart from '@Queries/Cart';
import * as PageProduct from '@Stores/PageProduct';

import type { UseQueryResult } from '@tanstack/react-query';
import type { PageProductData } from '@Pages/PageProduct/typings';

export interface AdditionalData {
  id: number;
  quantity: number;
}

export interface ModuleData {
  id: number;
  quantity: number;
}

export interface Params {
  productIds: number[];
  isSetConfigurator?: boolean;
  isConstructor?: boolean;
  pageData?: PageProductData;
  opts?: {
    additional?: AdditionalData[];
    module?: ModuleData[];
  };
}

export interface Result {
  earnedAmount: number;
  extraBonus?: boolean;
}

const useOrderBonuses = (params: Params): UseQueryResult<Result> => {
  const { productIds = [], isSetConfigurator, isConstructor, pageData, opts } = params;
  const { search } = useNavigation();
  const { region } = useRequest();
  const { data, isFetched } = Cart.useCartShortInfo();
  const parameterValues = PageProduct.getParameterValues();

  const cartCount = data?.count || 0;
  const keys = [
    'order-bonuses',
    ...productIds,
    search,
    cartCount,
    region,
    opts,
    parameterValues,
    pageData?.product?.id,
  ];

  return useQuery({
    queryKey: keys,
    queryFn: () => {
      if (isConstructor) {
        return ApiOrder.getConstructorBonuses({
          productIds,
          search,
          pageData,
          parameterValues,
          opts,
        });
      }
      return ApiOrder.getBonuses({ productIds, isSetConfigurator, opts });
    },
    enabled: isFetched,
    refetchOnMount: 'always',
  });
};

export default useOrderBonuses;
